import {useEffect, useState, useRef} from "react";
import {Chart} from "react-google-charts";
import {Api} from "../../../services/api";
import {t} from "i18next";
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import {AssistantUsage} from "./AssistantMonthlyStat";

const AssistantGlobalStat = () => {
    const [loaging, setLoading] = useState<boolean>(false);
    const [data, setData] = useState<(string | number)[][]>([
        [t("stat.platform"), t("stat.usage")],
    ]);

    const options = {
        backgroundColor: 'transparent',
        chartArea: {left: 20, top: 20, width: '90%', height: '95%'},
        is3D: true,
    }

    const getStat = () => {
        try {
            setLoading(true);
            Api.get<any>('stats/assistant-global-usage').then((response) => {
                const apiData = response.data;
                const newData = [[t("stat.assistant_stat_title"), t("stat.usage")]];
                Object.keys(apiData).forEach(key => {
                    newData.push([apiData[key].name, apiData[key].ct]);
                });
                setData(newData);
            }).catch((error) => {
                console.error(error)
            })
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getStat();
    }, []);

    return (
        <div className="card shadow-sm">
            <div className="card-header">
                <h5 className="mb-0">{t("stat.assistant_stat_title")}</h5>
                <p className="mb-0">{t("stat.assistant_stat_subtitle2")}</p>
            </div>
            <div className="card-body">
                <Chart
                    chartType="PieChart"
                    data={data}
                    options={options}
                    width={"100%"}
                    height={"400px"}
                />
            </div>
        </div>
    );
};

export default AssistantGlobalStat;
